// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__u7Yb+","footerNavWrapper":"Footer_footerNavWrapper__SH9wI"};